import { Paper } from "@mui/material";
import { Box } from "@mui/system";
import { ReactElement } from "react";
import Vtransactions from "../hooks/vtransactions/vtransactions";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function LedgerRoute(): ReactElement {
  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        background: "none",
        flex: 1,
        minWidth: 0,
        p: 2,
        gap: 2,
        width: "100%",
        position: "relative",
      }}
    >
      <Paper sx={{ flex: 1, minWidth: 0, border: "none", display: "flex" }}>
        <Vtransactions />
      </Paper>
    </Box>
  );
}
